export const validationRules = {
  async: false,
  validate: function(data: any, field: any) {
    //@ts-ignore
    const fields = JSON.parse(localStorage.getItem("fields"))
    data = data.original
    const fieldFind = fields.data.find((el: any) => el.slug == field)
    if (!fieldFind) return true
    if (!data[field]) {
      if (data.operational && JSON.parse(data.operational)) {
        if (fieldFind.operational_required) {
          throw new Error(`Campo ${fieldFind.name} é obrigatório`)
        }
      } else if (data.detached && JSON.parse(data.detached)) {
        if (fieldFind.detached_required) {
          throw new Error(`Campo ${fieldFind.name} é obrigatório`)
        }
      } else {
        if (fieldFind.required) {
          throw Error(`Campo ${fieldFind.name} é obrigatório`)
        }
      }
    }
    return true
  },
}
